import React, { useEffect, useState } from 'react';

import { GalleryProspect } from './Cell.jsx';
import { GalleryProspectArtists } from './Popup.jsx';

function Prospects({ url }) {
    const [filters, setFilters] = useState(null);
    const [prospects, setProspects] = useState([]);
    const [prospect, setProspect] = useState(null);

    useEffect(() => {
        fetchGalleriesProspects(url, filters);
    }, [url]);

    function fetchGalleriesProspects(url, filters) {
        Artcloud.api.get(url,
            filters,
            function (responseData) {
                setProspects(responseData);
            },
            function () {
                setProspects([]);
            }
        );
    }

    function handleFilterChange(e) {
        e.preventDefault();
        const _filters = filters || {};
        _filters[e.target.name] = e.target.value;
        setFilters(_filters);
        fetchGalleriesProspects(url, _filters);
    }

    return (
        <div className="fs-14">
            <div className="m-b-2">
                <label className="m-r-1">Filters:</label>
                <_ProspectYesNoFilter id="marketplace-select" name="hasMarketplaceSource" label="Has Marketplace Source" onChange={handleFilterChange} />
                <_ProspectYesNoFilter id="activated-select" name="hasEverActivated" label="Ever Activated" onChange={handleFilterChange} />
            </div>
            {prospects && prospects.length > 0 &&
                <div className="artist__grid--cont">
                    {prospects.map((d) => <GalleryProspect key={d.Slug} d={d}
                        handleOpen={() => setProspect(d)} />)}
                </div>}
            {prospect && <GalleryProspectArtists d={prospect} onClose={() => setProspect(null)} />}
        </div>
    );
}

function _ProspectYesNoFilter(props) {
    return (
        <>
            <label htmlFor={props.id}>{props.label}:</label>
            <select className="m-r-1" name={props.name} id={props.id} onChange={e => props.onChange(e)}>
                <option value="">--</option>
                <option value="yes">Yes</option>
                <option value="no">No</option>
            </select>
        </>
    );
}

export default Prospects;